import { useEffect, useState } from 'react';
import { APIEnv, BrowserEnv, DeploymentEnv } from './types/env.types';

export class Env {
    public static getCurrentDeploymentEnv() {
        return process.env.DEPLOYMENT_ENV;
    }

    public static getAPIEnv() {
        return process.env.DEPLOYMENT_ENV === DeploymentEnv.Dev ||
            process.env.DEPLOYMENT_ENV === DeploymentEnv.Test
            ? APIEnv.Test
            : APIEnv.Production;
    }
}

export const useBrowserEnv = () => {
    const [env, setEnv] = useState<BrowserEnv>(BrowserEnv.Server);

    useEffect(() => {
        if (typeof window === 'undefined') setEnv(BrowserEnv.Server);
        else setEnv(BrowserEnv.Browser);
    }, [typeof window]);

    return env;
};
